import './FinalCTA.css'

function FinalCTA() {
  return (
    <section className="final-cta section">
      {/* Background Effects */}
      <div className="cta-bg">
        <div className="cta-gradient"></div>
        <div className="cta-grid"></div>
      </div>

      <div className="container final-cta-container">
        <div className="cta-badge">
          <span className="badge-dot"></span>
          <span>Get started in minutes</span>
        </div>

        <h2 className="final-cta-title">
          Start with one module.
          <br />
          <span className="gradient-text">Expand when ready.</span>
        </h2>

        <p className="final-cta-description">
          Creating a Hubthrill account takes two minutes. You'll choose your first 
          module, set up your workspace, and be operational the same day.
        </p>

        <p className="final-cta-note">
          No annual contracts. No setup fees. No pressure to use everything at once.
        </p>
        
        <div className="final-cta-actions">
          <a href="/signup" className="btn btn-primary btn-lg">
            Create your Hubthrill account
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M5 12h14M12 5l7 7-7 7"/>
            </svg>
          </a>
          <div className="final-cta-secondary">
            <a href="/contact" className="link link-arrow">
              Talk to our team
            </a>
            <a href="/docs" className="link link-arrow">
              Read the documentation
            </a>
          </div>
        </div>
      </div>
    </section>
  )
}

export default FinalCTA
